/** Faint topographic contour motif — the brand's central image, used quietly
 *  behind hero surfaces. Decorative only. */
export function Contours({ opacity = 0.12 }: { opacity?: number }) {
  return (
    <svg
      className="contours"
      style={{ opacity }}
      viewBox="0 0 440 900"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <g fill="none" stroke="#F5F1E6" strokeWidth="0.7">
        {Array.from({ length: 11 }).map((_, i) => {
          const y = 60 + i * 80;
          return (
            <path
              key={i}
              d={`M-40 ${y} Q 120 ${y - 34}, 240 ${y} T 500 ${y + 14}`}
            />
          );
        })}
      </g>
    </svg>
  );
}
